import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';

import { useState } from 'react';
import { buildWhereFromFilterValues } from './filters';
import { gqlGetQuery } from '../graphql';

export const exportColumns = (t) => {
  return [
    { fieldName: 'id', fieldTitle: t('ID'), fieldType: 'TEXT' },
    { fieldName: 'code', fieldTitle: t('Production Code'), fieldType: 'TEXT' },
    { fieldName: 'productionDate', fieldTitle: t('Production Date'), fieldType: 'DATE' },
    { fieldName: 'notes', fieldTitle: t('Notes'), fieldType: 'TEXT' },
    { fieldName: 'productionLinesDetails', fieldTitle: t('Production Details'), fieldType: 'TEXT' },
  ];
};

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetQuery, { onCompleted: transformData });
    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);

    function transformData(data) {
      const recs = data.getProductions.data.map((values) => {
        return {
          ...values,
          productionLinesDetails:
            values.productionLines && values.productionLines.length > 0
              ? values.productionLines
                  .map(
                    (line) =>
                      `${line?.material?.name ?? ''} - ${line.qty ?? ''} units - ${
                        line.netWeight ?? ''
                      }kg`,
                  )
                  .join(', ')
              : '',
        };
      });
      const transformedData = {
        getProductions: {
          data: recs,
          recordCount: data?.getProductions?.recordCount,
        },
      };
      setResult([get, { loading, data: transformedData }]);
    }
    return result;
  }
  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };
  await exportXlsModal({
    apolloClient: client,
    exportFileName: 'Production Data',
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}
